import { useTranslation } from "react-i18next";
import Header from "@/components/main/Header";
import Hero from "@/components/main/Hero";
import ProductSlider from "@/components/main/ProductSlider";
import Products from "@/components/main/Products";
import InbodyUsed from "@/components/main/InbodyUsed";
import Blog from "@/components/main/Blog";
import Contents from "@/components/main/Contents";
import Footer from "@/components/main/Footer";

export default function Home() {
  const { t } = useTranslation();
  return (
    <>
      <Header />
      <Hero />
      <ProductSlider />
      <Products />
      <InbodyUsed />
      <Blog />
      <Contents
        title={t("main.contents.lets-get-in-touch")}
        desc={t("main.contents.lets-get-in-touch.desc")}
        link={"/contact/contact-us/"}
      />
      <Footer />
    </>
  );
}
